// Modül 10 - Final Değerlendirme - İnteraktif İçerikler

const cabinCrewContentsM10Interactive = {
  // ==================== ÜNİTE 1: KAPSAMLI TEKRAR ====================
  'CM-M10-U1-L1': {
    lesson_id: 'CM-M10-U1-L1',
    title: 'Modül 1-5 Tekrar',
    type: 'interactive',
    duration: 5,
    xp: 40,
    content: {
      title: '📚 Büyük Tekrar: Modül 1-5',
      intro: 'Tüm öğrendiklerini hatırla!',
      categories: [
        { icon: '✈️', title: 'Modül 1', examples: 'Mesleğin tanımı', desc: 'Güvenlik önce!' },
        { icon: '🎯', title: 'Modül 2', examples: 'Kriterler', desc: 'Takım uyumu #1' },
        { icon: '🤝', title: 'Modül 3', examples: 'Davranış', desc: 'Denge kur!' },
        { icon: '⚠️', title: 'Modül 4', examples: 'Hatalar', desc: 'Ezber ve ego!' },
        { icon: '❓', title: 'Modül 5', examples: 'Mülakat soruları', desc: 'STAR metodu!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Kabin memurunun #1 görevi?',
        options: [
          { text: 'Yemek servisi', isCorrect: false, feedback: '❌ İkincil görev!' },
          { text: 'Yolcu güvenliği', isCorrect: true, feedback: '✅ GÜVENLİK HER ZAMAN ÖNCE!' },
          { text: 'Eğlence', isCorrect: false, feedback: '❌ Bu pilot değil!' }
        ]
      }
    }
  },

  'CM-M10-U1-L2': {
    lesson_id: 'CM-M10-U1-L2',
    title: 'Modül 6-9 Tekrar',
    type: 'interactive',
    duration: 5,
    xp: 40,
    content: {
      title: '📚 Büyük Tekrar: Modül 6-9',
      intro: 'İleri düzey konuları hatırla!',
      categories: [
        { icon: '🧠', title: 'Modül 6', examples: 'Psikoloji', desc: 'Stres yönetimi!' },
        { icon: '👔', title: 'Modül 7', examples: 'İmaj', desc: 'İlk 7 saniye!' },
        { icon: '👥', title: 'Modül 8', examples: 'Grup mülakatı', desc: 'Koordinatör ol!' },
        { icon: '🎤', title: 'Modül 9', examples: 'Birebir mülakat', desc: 'STAR formatı!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Grup mülakatında en güvenli rol?',
        options: [
          { text: 'Baskın lider', isCorrect: false, feedback: '❌ Ego riski!' },
          { text: 'Koordinatör', isCorrect: true, feedback: '✅ Dengeli ve etkili!' },
          { text: 'Sessiz gözlemci', isCorrect: false, feedback: '❌ Pasif!' }
        ]
      }
    }
  },

  // ==================== ÜNİTE 2: FİNAL SİMÜLASYONU ====================
  'CM-M10-U2-L1': {
    lesson_id: 'CM-M10-U2-L1',
    title: 'Grup Mülakatı Final',
    type: 'scenario',
    duration: 10,
    xp: 60,
    scenario: {
      question: '👥 FİNAL SİMÜLASYON: Grup Mülakatı',
      context: 'Grup aktivitesinde siz dahil 8 aday var. Konu: "Havayolu müşteri memnuniyetini nasıl artırabilir?" Bir aday sürekli konuşuyor, diğer ikişi hiç konuşmuyor.',
      options: [
        { id: 'A', text: 'Baskın adayla rekabet et, fikirlerini çürut', isCorrect: false },
        { id: 'B', text: 'Sessizlere söz ver, fikirleri birleştir, özet oluştur', isCorrect: true },
        { id: 'C', text: 'Sadece kendi fikrini söyle ve bekle', isCorrect: false },
        { id: 'D', text: 'Değerlendirmeciye şikayet et', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 MÜKEMMEL LİDERLİK! Kapsayıcılık + Koordinasyon + Takım ruhu!',
        wrong: '❌ Rekabet, pasiflik veya şikayet YANLIŞ!'
      },
      explanation: 'Grup mülakatı formulü: Sessizleri dahil et + Baskınları nazikçe yönlendir + Fikirleri birleştir'
    }
  },

  'CM-M10-U2-L2': {
    lesson_id: 'CM-M10-U2-L2',
    title: 'Birebir Mülakat Final',
    type: 'scenario',
    duration: 10,
    xp: 60,
    scenario: {
      question: '🎤 FİNAL SİMÜLASYON: Birebir Mülakat',
      context: 'HR yöneticisi: "Bize birçok başvuru geliyor. Sizi neden diğerlerine tercih edelim? Beni ikna edin."',
      options: [
        { id: 'A', text: '"Diğerlerinden daha iyi olduğumu biliyorum"', isCorrect: false },
        { id: 'B', text: '"X yıl müşteri deneyimim, stres yönetimi becerilerim ve takım uyumum şirketinize değer katacak"', isCorrect: true },
        { id: 'C', text: '"Bu işi çok istiyorum, lütfen bana bir şans verin"', isCorrect: false },
        { id: 'D', text: '"Diğer adayları tanımıyorum, karşılaştıramam"', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 PROFESYONEL! Somut beceriler + Şirkete değer + Özgüven!',
        wrong: '❌ Kibir, yalvarma veya kaçınma YANLIŞ!'
      },
      explanation: 'Güçlü "neden seni seçelim" cevabı: Somut beceriler + Nasıl katkı sağlayacağın + Özgüvenli ama mütevazı'
    }
  },

  // ==================== ÜNİTE 3: FİNAL SINAVI ====================
  'CM-FINAL-EXAM': {
    lesson_id: 'CM-FINAL-EXAM',
    title: '🎓 FİNAL SINAVI',
    type: 'exam',
    duration: 20,
    xp: 250,
    exam: {
      questions: [
        // Modül 1-2: Temel Bilgiler
        { q: 'Kabin memurunun birincil görevi?', options: ['Servis', 'Güvenlik', 'Eğlence', 'Satış'], correct: 1 },
        { q: 'Grup mülakatında en önemli kriter?', options: ['Bilgi', 'Takım uyumu', 'Görünüm', 'Hız'], correct: 1 },
        { q: 'Boy kriteri neden var?', options: ['Estetik', 'Güvenlik ekipmanına erişim', 'Üniforma', 'Gelenek'], correct: 1 },
        { q: 'Minimum İngilizce seviyesi?', options: ['A2', 'B1', 'B2', 'C1'], correct: 2 },
        
        // Modül 3-4: Davranış ve Hatalar
        { q: 'Grup mülakatında ideal konuşma oranı?', options: ['%5', '%10-15', '%30', '%50'], correct: 1 },
        { q: '#1 eleme sebebi?', options: ['Bilgi eksikliği', 'Aşırı konuşma', 'Görünüm', 'Dil'], correct: 1 },
        { q: 'Kollar kavuşuk ne gösterir?', options: ['Rahatlık', 'Kapalılık', 'Güven', 'Liderlik'], correct: 1 },
        { q: 'Ezber cevap?', options: ['Güvenli', 'Riskli', 'Tavsiye', 'Gerekli'], correct: 1 },
        
        // Modül 5-6: Mülakat Soruları ve Psikoloji
        { q: 'Zor yolcuya ilk tepki?', options: ['Kural söyle', 'Empati kur', 'Purser\' a git', 'Görmezden gel'], correct: 1 },
        { q: 'Acil durumda öncelik?', options: ['Uçak', 'Eşya', 'Hayat', 'Zaman'], correct: 2 },
        { q: 'Power pose süresi?', options: ['10sn', '30sn', '2dk', '10dk'], correct: 2 },
        { q: 'Eleştiri aldığında?', options: ['Savun', 'Teşekkür et', 'Suskunlaş', 'Karşı çık'], correct: 1 },
        
        // Modül 7-8: Görünüm ve Grup
        { q: 'İlk izlenim kaç saniyede?', options: ['30', '7', '60', '120'], correct: 1 },
        { q: 'En güvenli grup rolü?', options: ['Lider', 'Koordinatör', 'Sessiz', 'Muhalif'], correct: 1 },
        { q: 'Baskın adaya karşı?', options: ['Kavga', 'Nazik yönlendirme', 'Susma', 'Kaytarma'], correct: 1 },
        { q: 'Sessiz adaya?', options: ['Umursama', 'Söz ver', 'Şikayet', 'Alay'], correct: 1 },
        
        // Modül 9: Birebir Mülakat
        { q: 'STAR\'da A?', options: ['Answer', 'Action', 'Always', 'All'], correct: 1 },
        { q: 'Zayıf yön cevabı?', options: ['Yok', 'Geliştiriyorum', 'Tembelim', 'Çok fazla'], correct: 1 },
        { q: '"Neden kabin memuru?" - Yanlış?', options: ['Hizmet', 'Gezi', 'Takım', 'Gelişim'], correct: 1 },
        { q: 'Mülakat sonunda soru?', options: ['Maaş', 'Eğitim süreci', 'Tatil', 'Sorma'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM10Interactive;
